export default "__VITE_ASSET__1f35f332__"